import { createFileRoute } from '@tanstack/react-router'
import { NFTsPage } from '@/features/assets/pages/nfts-page'

export const Route = createFileRoute('/_authenticated/_sidebar/investor/nfts')({
  component: NFTs,
})

function NFTs() {
  return <NFTsPage />
}

